module.exports = __webpack_public_path__ + "static/media/email2.05dee59c.png";